import { render } from "./OverviewCategory.vue?vue&type=template&id=3514dc4c&ts=true"
import script from "./OverviewCategory.vue?vue&type=script&lang=ts"
export * from "./OverviewCategory.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/bizerba/bizerba-web/light-modules/bizerba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__